var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOverlayButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m16 2.207-5.5 5.5-2-2-4 4-4.5-4.5.707-.707L4.5 8.293l4-4 2 2L15.293 1.5z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m16 6.707-5.5 5.5-2-2-4 4-4.5-4.5L.707 9 4.5 12.793l4-4 2 2L15.293 6z",
  clipRule: "evenodd"
})));
export default SvgOverlayButton;